export default "__VITE_ASSET__365ad76a__"